import type { IAttributes, IDirective, INgModelController } from "angular";
import { module } from "angular";
import "@progress/kendo-ui/js/kendo.datetimepicker";

import { isNil } from "lodash";
import { tz } from "moment-timezone";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";
import "./InputDateTimeDirective.scss";

const MOMENT_TIME_FORMAT = " HH:mm";

export default class InputDateTimeDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        dateFormat: "<", // string
        dateFuture: "<", // boolean, input is in future
        dateMax: "<", // Moment
        dateMin: "<", // Moment
        ignoreTime: "<", // boolean, ignore time for dateFuture validation
        inclusive: "<", // boolean, dateMin and dateMax is inclusive
        irLabel: "<",
        timeZone: "<",
    };

    public require = ["ngModel", "^form"];

    public template: string;

    public compile = InputDirectiveFunctions.compile(this.link); // eslint-disable-line @typescript-eslint/unbound-method

    constructor() {
        this.template = `
            <input
                autocomplete="off"
                type="text"
                date-format="{{dateFormat}}"
                ir-date-max="{{dateMax}}"
                ir-date-min="{{dateMin}}"
                ir-date-future="{{dateFuture}}"
                ir-valid-moment
                aa-field-group="ngModel"
                aa-label="{{irLabel | translate}}"
                k-format = "'{{dateFormat.replace('YYYY','yyyy').replace('DD','dd').replace('D','d')}} HH:mm'"
                k-parse-formats="['{{dateFormat.replace('YYYY','yyyy').replace('DD','dd').replace('D','d')}} HH:mm']"
                k-time-format="'HH:mm'"
                kendo-date-time-picker />
        `;
    }

    public link(scope: any, instanceElement: JQuery, instanceAttributes: IAttributes, ctrls: any[]) {
        InputDirectiveFunctions.link(scope, instanceElement, instanceAttributes);

        const ngModelCtrl = ctrls[0] as INgModelController;

        ngModelCtrl.$formatters.push((modelValue) => {
            if (scope.timeZone && modelValue) {
                return modelValue.clone().tz(scope.timeZone);
            }

            return modelValue;
        });

        // eslint-disable-next-line @typescript-eslint/unbound-method
        ngModelCtrl.$render = () => {
            if (ngModelCtrl.$viewValue) {
                scope.ngModel = ngModelCtrl.$viewValue.format((scope.dateFormat as string) + MOMENT_TIME_FORMAT);
            }
        };

        scope.$watch("ngModel", (newValue: any, oldValue: any) => {
            if (newValue && newValue !== oldValue) {
                const timeZone = scope.timeZone || tz.guess();
                const tzAwareDate = tz(newValue, (scope.dateFormat as string) + MOMENT_TIME_FORMAT, timeZone);
                ngModelCtrl.$setViewValue(tzAwareDate);
            } else if (!isNil(newValue) && newValue !== oldValue) {
                ngModelCtrl.$setViewValue(newValue);
            }
        });
    }
}

module("mmGui").directive("irInputDateTime", () => new InputDateTimeDirective());
